"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorUtils = void 0;
const getMessage = (error) => {
    var _a, _b;
    let errorMessage = "";
    if (error === null || error === void 0 ? void 0 : error.message)
        errorMessage = error === null || error === void 0 ? void 0 : error.message;
    if (error.isAxiosError) {
        errorMessage = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error;
    }
    return errorMessage || "Something went wrong";
};
exports.errorUtils = {
    getMessage,
};
//# sourceMappingURL=errorUtils.js.map